export default __webpack_public_path__ + "static/media/user-profile-icon.7a369c8f.svg";